<div class="grid">
    <div class="col-12">
      <div class="grid p-justify-center">
        <div class="col" style="text-align: center;">
          <h1>{{ title }}</h1>
        </div>
      </div>
    </div>
    <div class="col-12">
      <kanzi-floormap-toolbar></kanzi-floormap-toolbar>
      <kanzi-floormap-content
     [dataReport]="dataReport"
    ></kanzi-floormap-content>
      <!-- <kanzi-floormap-content
        [dataGroup]="dataGroup"  
        [floorData]="floorData??null" 
      ></kanzi-floormap-content> -->
    </div>
  </div>
  